// extracted by mini-css-extract-plugin
export default {"number":"linkOrdersModal_number__Xp5lG","currency":"linkOrdersModal_currency__Kc8iw","header":"linkOrdersModal_header__eQg55","removeButton":"linkOrdersModal_removeButton__O4eSP"};